import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import './RoundedPage.scss'

export default function RoundedPage({children, className, style, ...props}) {
  const handleStyle = () => {
    const styleAttr = (style)? style : {}

    return {
      ...styleAttr,
    };
  }

  return (
    <Fragment>
      <div className={`rounded-page ${className ? className : ''}`}  {...props} style={handleStyle()} >
        {children}
      </div>
    </Fragment>
  )}

RoundedPage.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  className: PropTypes.string
}